module.exports = __webpack_public_path__ + "static/undraw_scrum_board_cesn-26e52cd1b2f27b936d9c79e0c14ef63c.svg";